'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_SimpleSample$package$$anon$2(evaluator$5) {
  this.M7 = null;
  this.M7 = evaluator$5;
}
export { $c_Lsamples_SimpleSample$package$$anon$2 as $c_Lsamples_SimpleSample$package$$anon$2 };
$p = $c_Lsamples_SimpleSample$package$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_SimpleSample$package$$anon$2;
/** @constructor */
function $h_Lsamples_SimpleSample$package$$anon$2() {
}
export { $h_Lsamples_SimpleSample$package$$anon$2 as $h_Lsamples_SimpleSample$package$$anon$2 };
$h_Lsamples_SimpleSample$package$$anon$2.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.M7.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_SimpleSample$package$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_SimpleSample$package$$anon$2, "samples.SimpleSample$package$$anon$2", ({
  qT: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_SimpleSample$package$$anon$2 as $d_Lsamples_SimpleSample$package$$anon$2 };
